import VerticalLine from '@/assets/SpectrotelIcons/VerticalLine.svg'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import {
  ExpandLogoDark,
  HamburgerMenu,
  FourSquaresMobileDashboardHeaderIcon,
  CasesSuitCaseMobileDashboardHeaderIcon,
  NetworkLatencyGraphMobileDashboardHeaderIcon,
  AlertsLightMobileDashboardHeaderIcon,
  OrdersHandMobileDashboardHeaderIcon,
  // GradientMagnifyingGlassIcon,
  // GradientBellIcon,
} from '@/assets/svgIcons'
import { useAppDispatch } from '@/hooks/storeHooks/storehooks'
import {
  changeMenuStatus,
  setWebTour,
} from '@/redux-store/slices/menuItemSlice/menuItemSlice'
import { useAppSelector } from '@/hooks/storeHooks/storehooks'
import { useTab, TabType } from '@/contexts/TabContext'
import { AxiosResponse } from 'axios'
import whitelogo from '@/assets/Pictures/layer1.svg'
import TechChoiceLogo from '@/assets/Pictures/tech-choice.png'
import TechChoiceDarkLogo from '@/assets/Pictures/techchoiceexpandeddark.svg'
import GradiantSkelton from '@/components/atom/gradiantSkelton/gradiantSkelton'
// import DesignToggle from '@/components/DesignToggle'
import DependentDropdowns from './dynamicDropdown'
import Search from './Search/Search'
// import CheckboxDropdown from './checkBoxDropdown/CheckboxDropdown'
import { AccessibilityMenu } from './AccessibilityMenu/accessibilityMenu'
import Profile from '@/designs/new/containers/Profile/Profile'
import { useEffect, useState } from 'react'
import { fetchUserLoginCount, getSavedSites } from '@/services/apis/api'
import { SavedSitesResponse, Site } from '../Settings/savedSites'
import CheckboxDropdown from './checkBoxDropdown/CheckboxDropdown'
import { useWebTour } from '../../contexts/WebTourContext'
import { useAuth0 } from '@auth0/auth0-react'
// import DesignToggle from '@/components/DesignToggle'
import { Sparkles } from 'lucide-react'
// import { useDesign } from '@/contexts/DesignContext'

export type LogoApiResponse = {
  showCustomLogo: boolean
  organizationId: string
  images: {
    logoMiniLight: string
    logoLargeLight: string
    logoMiniDark: string
    logoLargeDark: string
  }
}

export type FetchEventsResponse = AxiosResponse<{ data: LogoApiResponse }>
export let hasCheckedLoginsCount = false
export const resetHasCheckedLoginsCount = () => {
  hasCheckedLoginsCount = false
}
const Header = () => {
  const menuExpandedFromStore = useAppSelector(state => state.menu.menuExpanded)
  const dispatch = useAppDispatch()
  const themeValue = useAppSelector(state => state.menu.value)
  const allowedPaths = useAppSelector(state => state.menu.paths) // Get allowed paths
  const location = useLocation()
  const navigate = useNavigate()
  const { activeTab, setActiveTab } = useTab()
  const { startTour } = useWebTour()
  const { user } = useAuth0()
  const isPortalDev =
    window.location.hostname.includes('portaldev') ||
    window.location.hostname === 'localhost'

  const showCheckboxDropdown = ['/home', '/overview', 'sitepage'].some(path =>
    location.pathname.includes(path),
  )
  // const { isNewDesign, isTransitioning, toggleDesign } = useDesign()
  // const { isMobile } = useResponsive()

  // const label = isNewDesign ? '✦ New design' : 'Try new design'

  const logoState = useAppSelector(state => state.logo)
  const show = logoState.logoShow
  const logoImages = logoState.images
  const loading = logoState.loading

  const logoLarge = logoImages?.logoLargeLight || ''
  const logoLargeDark = logoImages?.logoLargeDark || ''

  const isSpectrotel = !show
  const isDarkTheme =
    themeValue === 'dark' || themeValue === 'high-contrast-dark'

  const logoContent = isSpectrotel ? (
    <div className='w-[150px] h-[50px] md:w-auto md:max-w-[130px] md:h-[35px] flex items-center'>
      {isDarkTheme ? (
        <ExpandLogoDark />
      ) : (
        <img
          src={whitelogo}
          alt='logo'
          className='w-full h-full object-contain'
        />
      )}
    </div>
  ) : (
    <div className='w-[150px] h-[50px] md:w-auto md:max-w-[130px] md:h-[35px] flex items-center'>
      <img
        src={
          isDarkTheme
            ? logoLargeDark || TechChoiceDarkLogo
            : logoLarge || TechChoiceLogo
        }
        alt='Logo'
        className='w-full h-full object-contain'
      />
    </div>
  )

  const handleCloseButton = () => {
    navigate(-1)
  }

  const handleHamburgerClick = () => {
    dispatch(changeMenuStatus(!menuExpandedFromStore))
  }

  const tabs = [
    { id: 'dashboard' as TabType, label: 'Dashboard' },
    { id: 'network' as TabType, label: 'Network Performance' },
    { id: 'cases' as TabType, label: 'Cases' },
    { id: 'orders' as TabType, label: 'Orders' },
    { id: 'alerts' as TabType, label: 'Alerts' },
  ]

  const isTabAllowed = (tabId: TabType) => {
    if (tabId === 'dashboard') return true
    if (tabId === 'network')
      return allowedPaths.some(path =>
        path.includes('/technologyandnetworks/networkperformance'),
      )
    if (tabId === 'cases')
      return allowedPaths.some(path => path.includes('/support/casemanagement'))
    if (tabId === 'orders')
      return allowedPaths.some(path =>
        path.includes('/service-delivery/orders'),
      )
    if (tabId === 'alerts') return true
    return false
  }

  const visibleTabs = tabs.filter(tab => isTabAllowed(tab.id))
  console.log(visibleTabs, 'allowedPaths:', allowedPaths)

  // Check if we're on the dashboard page to show tabs
  const isDashboardPage =
    location.pathname === '/home' || location.pathname.includes('dashboard')

  const [savedSites, setSavedSites] = useState<Site[]>([])

  useEffect(() => {
    const fetch = async () => {
      const res = (await getSavedSites()) as SavedSitesResponse
      console.log(res?.data?.data?.sites, 'rifherfryfg')
      setSavedSites(res?.data?.data?.sites || [])
    }
    fetch()
  }, [])

  const checkLoginCount = async () => {
    if (!hasCheckedLoginsCount) {
      hasCheckedLoginsCount = true
      try {
        const res = (await fetchUserLoginCount()) as AxiosResponse<{
          data: { loginsCount: number }
          cached: boolean
        }>
        if (res.status === 200 && res.data?.data) {
          const loginsCount = res.data.data.loginsCount
          if (loginsCount === 1) {
            const hasStarted = sessionStorage.getItem(
              `webtour_autostarted_${user?.sub}`,
            )
            if (!hasStarted) {
              sessionStorage.setItem(`webtour_autostarted_${user?.sub}`, 'true')
              dispatch(setWebTour(true))
              startTour()
            }
          }
        }
      } catch (error) {
        console.error('Failed to fetch user login count:', error)
      }
    }
  }

  useEffect(() => {
    checkLoginCount()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  console.log(savedSites, 'savedSites')

  return (
    <>
      {/* ✅ Mobile Header */}
      <div className='bg-Header-primary shadow-md md:hidden'>
        {/* Top header bar */}
        <div className='flex items-center justify-between px-4 py-2'>
          <div className='flex'>
            <button className='text-xl mr-2' onClick={handleHamburgerClick}>
              <HamburgerMenu />
            </button>
            {!loading ? (
              <Link to={'/home'}>{logoContent}</Link>
            ) : (
              <GradiantSkelton className='w-32 h-8 rounded-radius-sm' />
            )}
          </div>

          <div className='flex gap-3 items-center text-xl'>
            {isPortalDev && (
              <Link
                to='/wiki'
                title='AI Wiki'
                className='flex h-8 w-8 items-center justify-center rounded-lg border border-secondary-border bg-secondary text-primary-foreground hover:bg-primary-active transition-all'
              >
                <Sparkles className='w-4 h-4 text-purple-400' />
              </Link>
            )}
            {/* <DesignToggle /> */}
            <Search variant='mobile' />
          </div>
        </div>

        {/* Tab Navigation - only show on dashboard pages */}
        {isDashboardPage && (
          <div className='bg-primary '>
            <div className='flex overflow-x-auto scrollbar-hide px-4 border-t border-disable'>
              {visibleTabs.map(tab => (
                <button
                  key={tab.id}
                  onClick={() => {
                    setActiveTab(tab.id)
                  }}
                  className={`relative px-4 py-2  whitespace-nowrap transition-colors -mb-px flex items-center gap-2 ${
                    activeTab === tab.id
                      ? 'text-primary-active-foreground border-primary-active-foreground z-50 font-semibold border-b-4 text-sm'
                      : 'text-primary-foreground  border-disable font-normal border-b-2 text-md'
                  }`}
                >
                  {tab.id === 'dashboard' && (
                    <FourSquaresMobileDashboardHeaderIcon />
                  )}
                  {tab.id === 'network' && (
                    <NetworkLatencyGraphMobileDashboardHeaderIcon />
                  )}
                  {tab.id === 'cases' && (
                    <CasesSuitCaseMobileDashboardHeaderIcon />
                  )}
                  {tab.id === 'orders' && (
                    <OrdersHandMobileDashboardHeaderIcon />
                  )}
                  {tab.id === 'alerts' && (
                    <AlertsLightMobileDashboardHeaderIcon />
                  )}
                  {tab.label}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* ✅ Desktop Header */}
      <div
        className='hidden md:flex bg-header-primary p-padding-xl shadow-md items-center w-full'
        data-testid='dropdown-menu'
      >
        <div className='flex justify-between items-center w-full min-w-0'>
          <div className='flex items-center gap-4'>
            {/* Site / Customer selector with tour target */}
            {/* <div id='tour-site-selector'> */}
            <DependentDropdowns />
            {/* </div> */}
          </div>
          <div className='flex-none'>
            <div className='flex flex-row justify-end gap-2 '>
              {location.pathname === '/visiodata' ? (
                <div className='flex items-center gap-4'>
                  <div className='bg-secondary h-11 w-11 flex justify-center items-center rounded-radius-full cursor-pointer'>
                    Z+
                  </div>
                  <div className='bg-secondary h-11 w-11 flex justify-center items-center rounded-radius-full cursor-pointer'>
                    Z-
                  </div>
                  <div className='bg-secondary h-11 w-11 flex justify-center items-center rounded-radius-full cursor-pointer'>
                    filter
                  </div>
                  <img
                    src={VerticalLine}
                    alt='vertical line'
                    className='h-12 w-5 ml-4'
                  />
                  <div className='bg-secondary h-11 w-11 flex justify-center items-center rounded-radius-full cursor-pointer'>
                    <button onClick={handleCloseButton}>X</button>
                  </div>
                </div>
              ) : (
                <div className='flex gap-2 items-center'>
                  <div className='flex flex-col xl:flex-row gap-2'>
                    {/* <DesignToggle /> */}
                    <Search variant='desktop' />
                  </div>
                  <div className='flex flex-col xl:flex-row gap-2'>
                    {showCheckboxDropdown && <CheckboxDropdown />}
                    <AccessibilityMenu />
                    {/* {isPortalDev && (
                      <Link
                        to='/wiki'
                        title='AI Wiki & Assistant'
                        className='flex items-center justify-center gap-1.5 px-3 py-1.5 rounded-lg border border-secondary-border bg-secondary hover:bg-primary-active hover:border-accent transition-all text-xs font-semibold text-primary-foreground group'
                      >
                        <Sparkles className='w-4 h-4 text-purple-400 group-hover:animate-pulse' />
                        <span className='hidden 2xl:inline'>AI Wiki</span>
                      </Link>
                    )} */}
                  </div>

                  <img
                    src={VerticalLine}
                    alt='vertical line'
                    className='h-18 dark:bg-invert'
                  />
                  <div className='flex justify-center items-center'>
                    <Profile />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Header
